import { API } from '@providers/ApiInterceptorProvider/useApiInterceptor';
import { IUploadFilesDto, IBtlDocument, IBtlUploadDocumentMetadata } from './types';

export const documentsApi = {
  getFileById: async (id: number) => {
    try {
      const response = await API.get(`/application/documents/${id}/file`, {
        responseType: 'blob',
      });

      return response.data;
    } catch (err: any) {
      throw new Error(err.response.data.message);
    }
  },
  uploadFile: async ({ filesData, applicationId }: IUploadFilesDto) => {
    try {
      return await Object.values(filesData).reduce(async (promise, fileData) => {
        await promise;

        const formData = new FormData();

        Object.entries(fileData).forEach(([key, value]) => {
          formData.append(key, value);
        });

        return await API.post(`/application/${applicationId}/document`, formData);
      }, Promise.resolve());
    } catch (err: any) {
      throw new Error(err.response.data.message);
    }
  },
  getBtlDocuments: async (applicationId: string): Promise<IBtlDocument[]> => {
    try {
      const response = await API.get<IBtlDocument[]>(`/monolith/docs?applicationId=${applicationId}`);
      return response.data;
    } catch (err: any) {
      throw new Error(err.response?.data?.message ?? err.message);
    }
  },
  uploadBtlDocument: async (caseId: string, file: File, metadata: IBtlUploadDocumentMetadata) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('metadata', JSON.stringify(metadata));

      return await API.post(`/monolith/btl-applications/${caseId}/documents`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (err: any) {
      throw new Error(err.response?.data?.message ?? err.message);
    }
  },
  getBtlFileById: async (id: number) => {
    try {
      const response = await API.get(`/monolith/docs/${id}/file`, {
        responseType: 'blob',
      });

      return response.data;
    } catch (err: any) {
      throw new Error(err.response?.data?.message ?? err.message);
    }
  },
};
